import { useQuery } from '@tanstack/react-query';
import { BusinessPluginApp } from './types';
import { PLUGINS } from 'queries/query-keys';
import PluginService from 'services/PluginService';
import { usePluginsEnabled } from './usePluginsEnabled';

export const useBusinessPluginApps = (enabled = false) => {
  const enablePlugins = usePluginsEnabled();

  const result = useQuery<BusinessPluginApp[]>({
    queryFn: () => PluginService.getBusinessPluginApps(),
    queryKey: PLUGINS.GET_BUSINESS_PLUGIN_APPS,
    enabled: enablePlugins || enabled,
  });

  return result;
};
